"use client";

import { useState } from "react";
import { Mail, CheckCircle, Sparkles } from "lucide-react";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success">("idle");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setStatus("success");
      setEmail("");
      setTimeout(() => setStatus("idle"), 4000);
    }
  };

  return (
    <section id="join" className="px-4 py-20 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <div className="relative overflow-hidden rounded-[2.5rem] bg-gradient-to-br from-primary to-primary-dark px-6 py-16 text-center shadow-2xl shadow-rose-500/25 sm:px-12">
          <div className="pointer-events-none absolute inset-0 -z-10 opacity-20">
            <div className="absolute -top-20 -left-20 h-64 w-64 rounded-full bg-white blur-3xl" />
            <div className="absolute -bottom-20 -right-20 h-64 w-64 rounded-full bg-orange-300 blur-3xl" />
          </div>

          <div className="mx-auto inline-flex items-center gap-2 rounded-full bg-white/20 px-4 py-1.5 text-sm font-medium text-white backdrop-blur-sm">
            <Sparkles className="h-4 w-4" />
            <span>Free to join · Cancel anytime</span>
          </div>

          <h2 className="mt-6 text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Become a PerkBestie insider
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-lg text-rose-100">
            Drop your email and Mia will send you the latest deals, drops, and bestie-only
            surprises.
          </p>

          <form onSubmit={handleSubmit} className="mx-auto mt-8 flex max-w-md flex-col gap-3 sm:flex-row">
            <div className="relative flex-1">
              <Mail className="absolute top-1/2 left-4 h-5 w-5 -translate-y-1/2 text-foreground/40" />
              <input
                type="email"
                required
                placeholder="you@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="h-14 w-full rounded-full border-0 bg-white pl-12 pr-5 text-foreground placeholder:text-foreground/40 focus:ring-2 focus:ring-white/50 focus:outline-none"
              />
            </div>
            <button
              type="submit"
              className="h-14 rounded-full bg-foreground px-8 text-base font-semibold text-white transition-colors hover:bg-foreground/90"
            >
              Join Now
            </button>
          </form>

          {status === "success" && (
            <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-white/20 px-4 py-2 text-sm font-medium text-white backdrop-blur-sm">
              <CheckCircle className="h-4 w-4" />
              You're in! Check your inbox for a welcome surprise.
            </div>
          )}

          <p className="mt-4 text-xs text-rose-200">
            No spam, ever. Unsubscribe with one click.
          </p>
        </div>
      </div>
    </section>
  );
}
